import { Card, Avatar } from "antd";
import { getMurphyPanelAsistente } from "../globals.js";

const { Meta } = Card;

const HeaderChat = () => {
  // const [avatarBorder, setAvatarBorder] = useState("2px solid green");
  // const [titleColor, setTitleColor] = useState("#000000");
  // const [imageAvatar, setImageAvatar] = useState("data:image/png;base64,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");
  // const [title, setTitle] = useState("Chat Panel Murphy 1.0");

  return (
    <>
      <Card
        style={{
          height: "100px",
          width: "100%",
          padding: "0px",
          margin: "0px",
          border: "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          alignContent: "center",
          gap: "10px",
          backgroundColor: "transparent",
        }}
        cover={
          <Avatar
            style={{ alignContent: "center", border: getMurphyPanelAsistente("logoColorBorder") }}
            size={48}
            src={getMurphyPanelAsistente("logo")}
          />
        }
      >
        <Meta
          style={{ textAlign: "center" }}
          title={
            <span
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: getMurphyPanelAsistente("titleColor"),
              }}
            >
              {getMurphyPanelAsistente("title")}
            </span>
          }
        />
      </Card>
    </>
  );
};
export default HeaderChat;


